import { useQuery } from '@tanstack/react-query';

import { queryClient } from '../components/queryClient';
import { useFleet } from '../hooks/useFleet';
import { useHasPermission } from '../hooks/useHasPermission';
import { Fleet } from '../interfaces';
import { VehicleService } from '../services/vehicle.service';

export const useVehicles = () => {
  const fleet = useFleet();
  const queryKey = ['vehicles', fleet.id];
  const hasPermission = useHasPermission('vehicles:read:list');

  const queryFn = () => VehicleService.getAll();

  return useQuery({
    queryKey,
    queryFn,
    enabled: !!fleet.id && hasPermission,
  });
};

export const refreshVehicles = (fleetId: Fleet['id']) => {
  // Make sure we refetch the event in the background, WHEN NEEDED - but display
  // the cached data in the meantime, instantenously
  queryClient.invalidateQueries(['vehicles', fleetId]);
};
